import React, { ReactNode, useState } from 'react';
import { Sidebar } from './Sidebar';
import { Menu } from 'lucide-react';

interface Props {
  children: ReactNode;
}

/** Authenticated shell — sidebar + scrollable content area. */
export const AppLayout: React.FC<Props> = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="vendor-shell">
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      {sidebarOpen && <button className="vendor-sidebar-overlay" aria-label="Close navigation" onClick={() => setSidebarOpen(false)} />}
      <main
        className="vendor-shell-main"
      >
        <header className="vendor-mobile-topbar">
          <button className="vendor-mobile-menu-button" type="button" aria-label="Open navigation" onClick={() => setSidebarOpen(true)}>
            <Menu size={20} />
          </button>
          <span>PayIQ Vendor</span>
        </header>
        {children}
      </main>
    </div>
  );
};
